import React, { useEffect, useMemo, useRef, useState } from "react";
import { Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Spinner } from "reactstrap";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { BreadcrumbShowCountlabel, Breadcrumb_inputName, GetVenderSupplierCustomer, commonPageField, commonPageFieldSuccess } from "../../../store/actions";
import { useHistory } from "react-router-dom";
import { goButtonPartyItemAddPageSuccess, goButtonPartyItemAddPage, savePartyItemsAction, savePartyItemsActionSuccess, editPartyItemIDSuccess, channalItemViewDetailAction, channalItemViewDetailActionSuccess } from "../../../store/Administrator/PartyItemsRedux/action";
import { globalTableSearchProps } from "../../../components/Common/SearchBox/MySearch";
import { C_Button, PageLoadingSpinner, SaveButton } from "../../../components/Common/CommonButton";
import * as url from "../../../routes/route_url";
import * as mode from "../../../routes/PageMode";
import BootstrapTable from "react-bootstrap-table-next";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { breadcrumbReturnFunc, metaTagLabel } from "../../../components/Common/CommonFunction";
import * as pageId from "../../../routes/allPageID";
import * as _cfunc from "../../../components/Common/CommonFunction";
import { C_Select, CInput, decimalRegx_3dit } from "../../../CustomValidateForm";
import { getPartyTypelist, getPartyTypelistSuccess } from "../../../store/Administrator/PartyTypeRedux/action";
import ChannelViewDetails from "./ChannelViewDetails";
import { vieBtnCss } from "../../../components/Common/ListActionsButtons";
import { changeCommonPartyDropDetailsAction } from "../../../store/Utilites/PartyDrodown/action";
import SaveButtonDraggable from "../../../components/Common/saveButtonDraggable";
import { getPartyListAPISuccess } from "../../../store/Administrator/PartyRedux/action";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";


function initialState(history) {

	let page_Id = '';
	let sub_Mode = history.location.pathname;

	if (sub_Mode === url.PARTYITEM) {
		page_Id = pageId.PARTYITEM;
	}
	else if (sub_Mode === url.CHANNEL_ITEM) {
		page_Id = pageId.CHANNEL_ITEM;
	}
	else if (sub_Mode === url.CUSTOMER_ITEM_ASSIN) {
		page_Id = pageId.CUSTOMER_ITEM_ASSIN;
	}
	return { page_Id }
};


export const getChangedParties = (Item, OriginalData) => {

	const RowData = OriginalData.find(o => o.Item === Item);

	const oldParties = RowData?.OriginalData || [];
	const newParties = RowData?.MutablePartyData || [];

	// Normalize (only compare ids + flag if needed)
	const normalize = (arr) =>
		arr.map(p => ({
			id: p.id,
			selectCheck: p.selectCheck
		}));

	const oldNormalized = normalize(oldParties);
	const newNormalized = normalize(newParties);

	// Find changed
	const changed = newNormalized.filter(newP => {
		const oldP = oldNormalized.find(o => o.id === newP.id);

		// New party added OR flag changed
		return !oldP || oldP.selectCheck !== newP.selectCheck;
	});

	return changed;
};
const initialshowModal = { RowId: null, ItemName: "", InitialData: [], ModalOpen: false }

const PartyItems = (props) => {

	const history = useHistory();
	const dispatch = useDispatch();
	const [subPageMode] = useState(history.location.pathname)
	const [pageMode, setPageMode] = useState(mode.defaultsave);
	const [userPageAccessState, setUserAccState] = useState("");
	const [searchQuery, setSearchQuery] = useState("");

	const [page_id] = useState(() => initialState(history).page_Id)
	const [partyIdSelect, setPartyIdSelect] = useState({ value: _cfunc.loginSelectedPartyID() })
	const [channelTypeSelect, setChannelTypeSelect] = useState('');

	const location = { ...history.location };
	const hasShowloction = location.hasOwnProperty(mode.editValue);
	const hasShowModal = props.hasOwnProperty(mode.editValue);
	const [showModal, setShowModal] = useState(initialshowModal);

	const [selectedParty, setSelectedParty] = useState(null);

	const [isDropdownDisabled, setIsDropdownDisabled] = useState(false);
	const [isSelected, setIsSelected] = useState(false);

	const lastVendorPartyId = useRef(null);


	const {
		postMsg,
		pageField,
		tableList,
		saveBtnloading,
		GoBtnlistloading,
		userAccess,
		PartyTypes,
		viewBtnLoading,
		partyItemListLoading,
		Customer,
		channeItemViewDetail
	} = useSelector((state) => ({
		Customer: state.CommonAPI_Reducer.vendorSupplierCustomer,
		saveBtnloading: state.PartyItemsReducer.saveBtnloading,
		GoBtnlistloading: state.PartyItemsReducer.partyItemListLoading,
		postMsg: state.PartyItemsReducer.postMsg,
		tableList: state.PartyItemsReducer.partyItem,
		userAccess: state.Login.RoleAccessUpdateData,
		pageField: state.CommonPageFieldReducer.pageField,
		PartyTypes: state.PartyTypeReducer.ListData,
		viewBtnLoading: state.PartyItemsReducer.channeItemViewBtnLoading,
		channeItemViewDetail: state.PartyItemsReducer.channeItemViewDetail,
		partyItemListLoading: state.PartyItemsReducer.partyItemListLoading,

	}));

	const { commonPartyDropSelect } = useSelector((state) => state.CommonPartyDropdownReducer);


	// const { partyList } = useSelector((state) => state.PartyMasterReducer);

	const CustomerOptions = (Customer || []).map((party) => ({
		label: party.Name,
		value: party.id,
	}));



	// Common Party select Dropdown useEffect


	useEffect(() => {

		if (subPageMode === url.CUSTOMER_ITEM_ASSIN) {
	
			// Same PartyID sathi duplicate API call stop
			if (lastVendorPartyId.current !== commonPartyDropSelect?.value) {
	
				lastVendorPartyId.current = commonPartyDropSelect?.value;
	
				dispatch(
					GetVenderSupplierCustomer({
						subPageMode,
						PartyID: commonPartyDropSelect.value
					})
				);
			}
		}
	
		if (
			(commonPartyDropSelect.value > 0) &&
			!(subPageMode === url.CHANNEL_ITEM) &&
			!(subPageMode === url.CUSTOMER_ITEM_ASSIN)
		) {
			goButtonHandler("onload");
		} else {
			partyOnChngeButtonHandler();
		}
	
	}, [commonPartyDropSelect]);


	// useEffect(() => {
	// 	if (subPageMode === url.CUSTOMER_ITEM_ASSIN) {
	// 		dispatch(GetVenderSupplierCustomer({ subPageMode, PartyID: commonPartyDropSelect.value }));
	// 	}
	// 	if ((commonPartyDropSelect.value > 0) && !(subPageMode === url.CHANNEL_ITEM) && !(subPageMode === url.CUSTOMER_ITEM_ASSIN)) {
	// 		goButtonHandler("onload")
	// 	} else {
	// 		partyOnChngeButtonHandler()
	// 	}
	// }, [commonPartyDropSelect])

	useEffect(() => {

		dispatch(commonPageFieldSuccess(null));
		dispatch(getPartyTypelist());
		// dispatch(getPartyListAPI());

		if (hasShowModal !== true) {
			dispatch(commonPageField(page_id));
		}
		if (!(subPageMode === url.PARTYITEM) && !(subPageMode === url.CUSTOMER_ITEM_ASSIN)) {
			dispatch(changeCommonPartyDropDetailsAction({ isShow: false }))//change party drop-down show false
		}

		return () => {
			dispatch(changeCommonPartyDropDetailsAction({ isShow: true }))//change party drop-down restore show state	
			dispatch(getPartyTypelistSuccess([]));
			dispatch(getPartyListAPISuccess([]));
			dispatch(goButtonPartyItemAddPageSuccess([]));
		}
	}, []);

	useEffect(() => {
		let userAcc = null;
		let locationPath = location.pathname;

		if (hasShowModal) {
			locationPath = props.masterPath;
		}

		userAcc = userAccess.find((inx) => {
			return `/${inx.ActualPagePath}` === locationPath;
		});

		if (userAcc) {
			setUserAccState(userAcc);
			if (!props.isAssing) {
				breadcrumbReturnFunc({ dispatch, userAcc });
			}
		}
	}, [userAccess]);

	useEffect(() => {

		if (hasShowloction || hasShowModal) {
			let hasEditVal = null;
			if (hasShowModal) {
				hasEditVal = props.editValue;
				setPageMode(props.pageMode);
			} else if (hasShowloction) {
				setPageMode(location.pageMode);
				hasEditVal = location.editValue;
			}
			if (hasEditVal) {
				const { Party, PartyName, PartyItem = [] } = hasEditVal;
				const convArr = PartyItem.map((item) => {
					item.selectCheck = false;
					if (item.Party > 0) {
						item.selectCheck = true;
					}
					return item;
				});
				setPartyIdSelect({ value: Party, label: PartyName })
				dispatch(goButtonPartyItemAddPageSuccess(convArr));
				dispatch(Breadcrumb_inputName(PartyName));
			}
			dispatch(editPartyItemIDSuccess({ Status: false }));
		}
		return () => {
			props?.isOpenModal && props.isOpenModal(false)
		}
	}, []);



	useEffect(() => {
		
		if (((channeItemViewDetail.Status === true && channeItemViewDetail.StatusCode === 200)) || (tableList.length > 0)) {
			setShowModal(prev => {
				// ✅ clone previous list (important)
				const updatedList = (prev.InitialData.length > 0 ? prev.InitialData : tableList);

				if (channeItemViewDetail.ModelOpen) {
					const index = updatedList.findIndex(
						item => item.Item === channeItemViewDetail.Item
					);

					if (index !== -1) {
						// ✅ update existing item
						updatedList[index] = {
							...updatedList[index],
							MutablePartyData: ((updatedList[index]?.MutablePartyData?.length > 0) ? updatedList[index]?.MutablePartyData : channeItemViewDetail.Data) || [],
							OriginalData: channeItemViewDetail.Data
						};
					} else {
						// ✅ add new item (if not exists)
						updatedList.push({
							Item: channeItemViewDetail.Item,
							MutablePartyData: structuredClone(channeItemViewDetail.Data),
							OriginalData: channeItemViewDetail.Data
						});
					}
				}

				return {
					...prev, // ✅ keep old state
					RowId: channeItemViewDetail?.Item,
					ItemName: channeItemViewDetail?.ItemName,
					InitialData: updatedList,
					ModalOpen: channeItemViewDetail.ModelOpen,
				};
			});
		}
	}, [channeItemViewDetail, tableList]);

	useEffect(() => {
		if (postMsg.Status === true && postMsg.StatusCode === 200) {
			dispatch(savePartyItemsActionSuccess({ Status: false }));
			dispatch(channalItemViewDetailActionSuccess({ Status: false }))
			setShowModal(initialshowModal)
			setSelectedParty(null);
			setIsDropdownDisabled(false);
			setIsSelected(false);
			dispatch(goButtonPartyItemAddPageSuccess([]));
			dispatch(Breadcrumb_inputName(""));
			if (pageMode === mode.assingLink) {
				customAlert({
					Type: 1,
					Message: postMsg.Message,
				});
				props.isOpenModal(false);
			} else {
				customAlert({
					Type: 1,
					Message: postMsg.Message,
				});
			}
		} else if (postMsg.Status === true) {
			dispatch(savePartyItemsActionSuccess({ Status: false }));
			customAlert({
				Type: 3,
				Message: JSON.stringify(postMsg.Message),
			});
		}
	}, [postMsg]);

	useEffect(() => {
		_cfunc.tableInputArrowUpDounFunc("#table_Arrow")

	}, [tableList]);

	const channelDropdownOptions = useMemo(() => {
		return PartyTypes.map(item => ({ value: item.id, label: item.Name }))
	}, [PartyTypes]);

	globalTableSearchProps({
		onSearch: (text) => {
			setSearchQuery(text);
		},
	});

	const groupWiseItemArray = useMemo(() => {
		const groupItemsByGroup = (items) => {

			const groupedItems = items.reduce((result, item) => {
				const { GroupName, ...rest } = item;
				if (!result[GroupName]) {
					result[GroupName] = [];
				}
				result[GroupName].push(rest);
				return result;
			}, {});
			return Object.entries(groupedItems).map(([group, items]) => ({ group, items, })
			);
		};
		return groupItemsByGroup(tableList);
	}, [tableList]);

	const filterdItemWise_tableData = useMemo(() => {
		const groupWiseItemNewArray = groupWiseItemArray
			.map(({ items, ...rest }) => ({
				...rest,
				items: items.filter((item) => {
					return (
						item.ItemName.toLowerCase().includes(searchQuery.toLowerCase()) ||
						String(item.Item).toLowerCase().includes(searchQuery.toLowerCase())
					);
				}),
			}))
			.filter((row) => row.items.length > 0);



		const numberOfItems = groupWiseItemNewArray.reduce((total, group) => total + group.items.length, 0);

		dispatch(BreadcrumbShowCountlabel(`Groups:${numberOfItems}`));
		return groupWiseItemNewArray
	}, [searchQuery, groupWiseItemArray]);





	const tableColumns = [
		{
			text: "Item ID",
			dataField: "Item",
			sort: true,
			style: {
				width: "100px",
			},
		},
		{
			text: "Item Name",
			dataField: "ItemName",
			sort: true,
			style: {
				width: "700px",
			},
		},

		{
			text: "Quantity",
			dataField: "Quantity",
			hidden: !(subPageMode === url.CUSTOMER_ITEM_ASSIN),
			formatter: (cell, row) => {
				const handleChange = (e) => {
					const newValue = parseFloat(e.target.value) || 0;
					row.Quantity = Number(_cfunc.roundFixed(newValue, 3));      // 3 decimal round
				};

				return (
					<CInput
						key={row.Item}
						id={row.Item}
						type="text"
						placeholder="Quantity"
						className="text-end"
						defaultValue={row.Quantity || ""}
						onChange={handleChange}
						style={{ width: "90px", textAlign: "right" }}
						cpattern={decimalRegx_3dit}
					/>
				);
			},
			headerStyle: { width: "120px", textAlign: "center" },
		},



		{
			text: "Party Assigned",
			dataField: "",
			hidden: (subPageMode === url.PARTYITEM || subPageMode === url.CUSTOMER_ITEM_ASSIN || pageMode === mode.assingLink),
			formatExtraData: { viewBtnLoading, showModal },
			formatter: (cell, row, __, { viewBtnLoading, showModal }) => {

				let ChangeParties = []
				if (showModal.InitialData.length > 0) {
					ChangeParties = getChangedParties(row.Item, showModal.InitialData)
				}
				row["ChangeParties"] = ChangeParties
				return (
					<div key={row.Item} style={{ display: "flex", alignItems: "center", gap: "10px" }}>

						{/* Button */}
						<C_Button
							className={vieBtnCss}
							loading={(viewBtnLoading === row.Item) && true}
							spinnerColor='white'
							onClick={() => {
								if (row.selectCheck === false) {
									customAlert({
										Type: 3,
										Message: "Please assign the item to a channel before assigning it to parties.",
									})
									return
								}

								const jsonBody = JSON.stringify({
									PartyType: channelTypeSelect.value,
									Item: row.Item,
								})

								dispatch(channalItemViewDetailAction({
									jsonBody,
									btnId: row.Item,
									ItemName: row.ItemName,
									ModelOpen: true
								}))
							}}
						>
							{!(viewBtnLoading === row.Item) && <i className="bx bxs-show font-size-16" />}
						</C_Button>

						{/* Counts Section */}
						<div style={{ display: "flex", alignItems: "center", gap: "12px" }}>

							{/* Assigned */}
							{row.AssignedPartyCount !== 0 && (
								<span>
									Assigned ({row.AssignedPartyCount}) Parties
								</span>
							)}

							{/* Recent Updates (Highlighted) */}
							{ChangeParties.length > 0 && (
								<span
									style={{
										color: "#ffffff",
										backgroundColor: "rgb(22 181 93)",
										padding: "2px 8px",
										borderRadius: "12px",
										fontSize: "12px",
										fontWeight: "500"
									}}
								>
									Update ({ChangeParties.length}) Parties
								</span>
							)}

						</div>

					</div>
				)
			}

		},
		{
			text: 'Not Available For Ordering',
			dataField: '',
			hidden: (subPageMode === url.PARTYITEM || subPageMode === url.CUSTOMER_ITEM_ASSIN || hasShowModal === true),

			formatter: (cell, row) => {

				const OrderAvailableHandler = ({ cell, row, event }) => {

					let checked = event.target.checked
					row["IsAvailableForOrdering"] = checked
				}
				return <div className="" key={row.Item}>
					<Input type="checkbox"

						onChange={(event) => { OrderAvailableHandler({ cell: cell, row: row, event: event }) }}
						defaultChecked={row.IsAvailableForOrdering}
						disabled={!row.selectCheck}
						style={(!row.selectCheck) ? {
							opacity: 0.5,
							backgroundColor: "#ababab82",
						} : {}}
					/>
				</div>
			}

		},
	];

	function goButtonHandler(Type) {
		if ((!selectedParty) && Type !== "onload" && (subPageMode === url.CUSTOMER_ITEM_ASSIN)) {
			customAlert({
				Type: 3,
				Message: alertMessages.selectCustomerName,
			});
			return;
		}
		setIsSelected(true);
		setIsDropdownDisabled(true);
		try {
			// PartyID select based on subPageMode
			const SelectedPartyID = (subPageMode === url.CUSTOMER_ITEM_ASSIN && selectedParty?.value)
				? selectedParty.value
				: commonPartyDropSelect.value;

			const jsonBody = {
				..._cfunc.loginJsonBody(),
				PartyID: SelectedPartyID,
				PartyTypeID: channelTypeSelect.value
			};

			dispatch(goButtonPartyItemAddPage({ jsonBody, subPageMode }));
		}
		catch (error) {
			console.error("Error in goButtonHandler:", error);
		}
		return;
	};


	function partyOnChngeButtonHandler() {

		setShowModal(initialshowModal)
		dispatch(goButtonPartyItemAddPageSuccess([]));
	}

	const rowSelected = (tableArray) => {

		return tableArray.map((index) => (index.selectCheck && index.Item));
	};
	const nonSelectedRow = (tableArray) => {

		var noSelectedIds = [];
		if (subPageMode === url.CHANNEL_ITEM) {
			noSelectedIds = tableArray
				.filter(row => ((row.InPartyItem == true || (getChangedParties(row.Item, showModal.InitialData).length > 0))))
				.map(row => row.Item);
		} else if (subPageMode === url.PARTYITEM) {
			noSelectedIds = tableArray
				.filter(row => (row.InStock == true))
				.map(row => row.Item);
		}
		return noSelectedIds;
	};


	const tableSelectCheckConfig = ({
		rowSelected = '',
		nonSelectable = [],
		position,
		headLabel,
		bgColor = "#9dadf09e",
		disabledWithMsg = '',
		keyField,
		tableData = []
	}) => ({

		mode: "checkbox",
		bgColor: bgColor,

		onSelectAll: (isSelecte) => {
			tableData.forEach(ele => {
				const isNonSelectable = nonSelectable.includes(ele[keyField]);
				const isBomDisabled = ele.IsBOMItem === true; // 👈 check here
				if (!isNonSelectable && !isBomDisabled) {
					ele.selectCheck = isSelecte;
				}
			});
		},

		onSelect: (row, event) => {
			const isNonSelectable = nonSelectable.includes(row[keyField]);
			const isBomDisabled = row.IsBOMItem === true; // 👈 check here
			if (isNonSelectable || isBomDisabled) {
				return;
			}
			row.selectCheck = event;
		},

		selected: rowSelected,
		selectColumnPosition: position ? position : "right",

		attrs: () => ({ 'data-label': "Select" }),

		selectionHeaderRenderer: (head) => {
			// only count rows that are not BOM and not in nonSelectable
			const selectableRows = tableData.filter(
				r => !nonSelectable.includes(r[keyField]) && !r.IsBOMItem
			);

			const allSelected = selectableRows.length > 0 && selectableRows.every(r => r.selectCheck);

			return (
				<div>
					<Input type="checkbox" checked={allSelected} />
					<label style={{ paddingLeft: "7px" }}>
						{headLabel ? headLabel : "SelectAll"}
					</label>
				</div>
			);
		},


		selectionRenderer: ({ mode, checked, rowKey, ...rest }) => {
			const rowData = tableData.find(r => r[keyField] === rowKey);

			const isNonSelectable = nonSelectable.includes(rowKey);
			const isBomDisabled = rowData?.IsBOMItem === true; // 👈 check here

			if (isNonSelectable || isBomDisabled) {
				return (
					<>
						<Input
							type="checkbox"
							{...rest}
							disabled
							checked={rowData?.selectCheck}
							style={!rowData?.selectCheck ? {
								opacity: 0.5,
								backgroundColor: "#ababab82",
							} : {}}
						/>
						&nbsp;&nbsp;
						<samp className="text-danger">
							{isBomDisabled ? " Is BOM Item" : disabledWithMsg}
						</samp>

						&nbsp;&nbsp;
						{rowData?.isItemMap ? (
							<samp className="text-danger">(Item Not Map)</samp>
						) : null}
					</>
				);
			} else {
				return (
					<>
						<Input type="checkbox" checked={checked} {...rest} />&nbsp;&nbsp;&nbsp;
						{rowData?.isItemMap ? (
							<samp className="text-danger">Item Not Map</samp>
						) : null}
					</>
				);
			}
		}
	});


	const SaveHandler = (event) => {
		event.preventDefault();

		const selectedItems = groupWiseItemArray.flatMap(group => group.items);

		if (subPageMode === url.PARTYITEM) {
			const UploadSalesDatafromExcelParty = _cfunc.loginUserDetails().UploadSalesDatafromExcelParty;

			const filteredDataExists = selectedItems.some(row => {

				return UploadSalesDatafromExcelParty === 1 && row.isItemMap === true;
			});

			if (filteredDataExists) {
				customAlert({
					Type: 4,
					Message: "Item Not Map",
				});
				return;
			}
		}


		try {
			let jsonBody;

			if (subPageMode == url.CHANNEL_ITEM) {

				const changedItems = [];

				showModal.InitialData?.forEach(item => {
					const selected = selectedItems.find(s => s.Item === item.Item);


					const itemChanged =
						item.selectCheck !== selected.selectCheck ||
						item.IsAvailableForOrdering !== selected.IsAvailableForOrdering;

					// Party arrays
					const oldParties = item?.OriginalData || [];
					const newParties = item?.MutablePartyData || [];

					// detect changed parties
					const oldMap = new Map(
						oldParties.map(op => [op.id, op.selectCheck])
					);

					const changedParties = newParties.filter(p => {
						return oldMap.get(p.id) !== p.selectCheck;
					});


					// if item flag changed → apply for all parties
					if (itemChanged) {
						changedItems.push({
							Item: selected.Item,
							Party: 0,
							PartyType: channelTypeSelect.value,
							IsAvailableForOrdering: selected.IsAvailableForOrdering ? 1 : 0,
							Quantity: 0,
							IsselectedItem: selected.selectCheck
						});

					}

					if (changedParties.length > 0) {
						changedParties.forEach(p => {
							changedItems.push({
								Item: selected.Item,
								Party: p.id,
								PartyType: channelTypeSelect.value,
								IsAvailableForOrdering: selected.IsAvailableForOrdering ? 1 : 0,
								Quantity: 0,
								IsselectedItem: p.selectCheck
							});
						});
					}

				});

				if (changedItems.length === 0) {
					customAlert({
						Type: 4,
						Message: "Select Atleast One Item",
					});
					return;
				}

				jsonBody = JSON.stringify(changedItems);
			} else {

				const selectedItems = groupWiseItemArray.flatMap(group => group.items.filter(item => item.selectCheck));

				if (selectedItems.length === 0 && !(_cfunc.IsSweetAndSnacksCompany())) {
					customAlert({
						Type: 4,
						Message: "Select Atleast One Item",
					});
					return;
				}

				const ItemData = selectedItems.map((index) => ({
					Item: index.Item,
					IsAvailableForOrdering: index.IsAvailableForOrdering ? 1 : 0,
					Quantity: index.Quantity || 0,

				}));
				let Party_ID = null;
				if ((pageMode === mode.assingLink)) {
					Party_ID = partyIdSelect.value
				} else if (subPageMode === url.CUSTOMER_ITEM_ASSIN) {
					Party_ID = selectedParty?.value;
				} else if (subPageMode === url.PARTYITEM) {
					Party_ID = commonPartyDropSelect.value;
				} else {
					Party_ID = _cfunc.loginSelectedPartyID();
				}

				jsonBody = JSON.stringify({
					Party: Party_ID,
					Items: ItemData
				});
			}
			dispatch(savePartyItemsAction({ jsonBody, subPageMode }));
		} catch (w) {
			
		}
	};


	const ChannelTypeDropdown = () => {
		if (subPageMode === url.CHANNEL_ITEM) {
			return (
				<div className="px-2 c_card_header text-black mb-1">
					<div className="row pt-2">
						<Col sm="5">
							<FormGroup className="row">
								<Label className="col-sm-5 p-2" style={{ width: "120px" }}>
									Channel Type
								</Label>
								<Col sm="6">
									<C_Select
										name="Name"
										value={channelTypeSelect}
										isDisabled={(filterdItemWise_tableData.length > 0)}
										className="react-dropdown"
										classNamePrefix="dropdown"
										styles={{
											menu: (provided) => ({ ...provided, zIndex: 2 }),
										}}
										options={channelDropdownOptions}
										onChange={(e) => { setChannelTypeSelect(e) }}
									/>
								</Col>
							</FormGroup>
						</Col>

						<Col sm="1">
							{((filterdItemWise_tableData.length === 0)) ? (
								<C_Button
									type="button"
									loading={GoBtnlistloading}
									className="btn btn-outline-primary border-1 font-size-12 text-center"
									onClick={(e) => {
										goButtonHandler(e)
									}}
								>
									Select
								</C_Button>
							) : (
								<C_Button
									type="button"
									spinnerColor={"info"}
									className="btn btn-outline-info border-1 font-size-12 "
									onClick={() => {
										dispatch(goButtonPartyItemAddPageSuccess([]));
										dispatch(channalItemViewDetailActionSuccess({ Status: false }));

										setShowModal(initialshowModal)
									}}
								>Change</C_Button>
							)}
						</Col>
					</div>
				</div>
			);
		}
		return null
	};
	var IsEditMode_Css = ''
	if (props.isAssing) { IsEditMode_Css = "1%" };

	return (
		<>
			<PageLoadingSpinner isLoading={(GoBtnlistloading || !pageField)} />
			{userPageAccessState && (
				<div className="page-content" >
					<Container fluid>
						<MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>

						{((showModal.ModalOpen) && (subPageMode === url.CHANNEL_ITEM)) && (
							<ChannelViewDetails OriginalData={showModal.InitialData} ModalOpen={showModal.ModalOpen} ItemName={showModal.ItemName} RowId={showModal.RowId} setShowModal={setShowModal} />
						)}


						<Card className="text-black">
							<CardHeader className="card-header text-black c_card_header">
								<h4 className="card-title text-black">
									{userPageAccessState.PageDescription}
								</h4>
									<p className="card-title-desc text-black" dangerouslySetInnerHTML={{ __html: userPageAccessState.PageDescriptionDetails }} />
							</CardHeader>

							<CardBody style={{ backgroundColor: "#whitesmoke" }}>
								{partyItemListLoading && !(subPageMode === url.CUSTOMER_ITEM_ASSIN) ?
									<div className="text-center my-4">
										<Spinner color="primary" />
										<div>Loading Items...</div>
									</div> :
									<>
										<ChannelTypeDropdown />
										{(subPageMode === url.CUSTOMER_ITEM_ASSIN) && (
											<div className="px-2 c_card_header text-black mb-1">
												<div className="row p-2">
													<Col sm="5">
														<FormGroup className="row">
															<Label className="col-sm-5 mt-2" style={{ width: "120px" }}>
																<b>Customer</b>
															</Label>
															<Col sm="6">
																<C_Select
																	name="PartyID"
																	className="react-dropdown"
																	classNamePrefix="dropdown"
																	placeholder="Select"
																	value={selectedParty}
																	isDisabled={isDropdownDisabled}
																	styles={{
																		menu: (provided) => ({ ...provided, zIndex: 2 }),
																	}}
																	options={CustomerOptions}
																	onChange={(e) => {
																		setSelectedParty(e)

																	}}
																/>
															</Col>
														</FormGroup>
													</Col>
													<Col sm="1">
														{!isSelected ? (
															<C_Button
																type="button"
																loading={GoBtnlistloading}
																className="btn btn-outline-primary border-1 font-size-12 text-center mt-1"
																onClick={(e) => {

																	goButtonHandler(e);


																}}
															>
																Select
															</C_Button>
														) : (
															<C_Button
																type="button"
																spinnerColor={"info"}
																className="btn btn-outline-info border-1 font-size-12 mt-1 "
																onClick={() => {
																	setSelectedParty(null);
																	setIsDropdownDisabled(false);
																	setIsSelected(false);
																	dispatch(goButtonPartyItemAddPageSuccess([]));
																}}
															>
																Change
															</C_Button>
														)}
													</Col>
												</div>
											</div>
										)}









										{filterdItemWise_tableData.length > 0 ? (
											<>
												{filterdItemWise_tableData.map((i, key) => (
													<div key={i.group}>
														<Label
															style={{
																background: "#efefef",
																padding: "7px 10px 0px 8px",
																borderRadius: "3px",
															}}
														>
															<h6> Group : {i.group ? i.group : `No Group Assign`}</h6>
														</Label>
														<div className="table">
															<BootstrapTable
																keyField={"Item"}
																key={`table-key-${i.group}-${key}`}
																data={i.items}
																columns={tableColumns}
																Item="table_Arrow"
																selectRow={
																	tableSelectCheckConfig({
																		// selectAllCheck({
																		rowSelected: rowSelected(i.items),
																		disabledWithMsg: subPageMode == url.PARTYITEM && "In-stock",
																		keyField: "Item",
																		bgColor: '',
																		selectedDisabled: nonSelectedRow(i.items),
																		tableData: i.items,
																		nonSelectable: [
																			...nonSelectedRow(i.items),
																			...i.items.filter(r => r.IsBOMItem).map(r => r.Item),  // 👈 Add BOM items here
																		],
																	})}

																// cellEdit={cellEditFactory({ mode: 'click', blurToSave: true })}
																noDataIndication={
																	<div className="text-danger text-center ">
																		Items Not available
																	</div>
																}
																classes={"table align-middle table-nowrap table-hover"}
															/>
														</div>
													</div>
												))}
											</>
										) : (
											<>
												<BootstrapTable
													keyField={"Item"}
													data={[]}
													columns={tableColumns}
													noDataIndication={
														<div className="text-danger text-center ">
															Items Not available
														</div>
													}
												/>
											</>
										)}
									</>
								}
								<SaveButtonDraggable>
									<SaveButton
										loading={saveBtnloading}
										pageMode={pageMode}
										userAcc={userPageAccessState}
										module={"PartyItems"}
										onClick={SaveHandler}
									/>
								</SaveButtonDraggable>
							</CardBody>
						</Card>
					</Container >
				</div >
			)}
		</>
	);
};

export default PartyItems;
